export type ScheduledReportType = 'shift' | 'cash';

export type ScheduledReportFormat = 'pdf' | 'excel';

export type ScheduledReportStatus = 'active' | 'paused';

/** Cash: daily|weekly|monthly|shift_end. Shift: shift_end|daily. */
export type ScheduledReportFrequencyKind = 'daily' | 'weekly' | 'monthly' | 'shift_end';

export type ScheduledReportFrequency =
  | { kind: 'daily' }
  | { kind: 'weekly'; weekday: string }
  | { kind: 'monthly'; day: number }
  | { kind: 'shift_end' };

/** Row shown in Active schedules table. */
export interface ScheduledReport {
  id: string;
  report_type: ScheduledReportType;
  location_ids: string[];
  location_label: string;
  employee_ids: string[];
  employee_label: string;
  frequency: ScheduledReportFrequency;
  delivery_time: string;
  individual_reports: boolean;
  start_date: string;
  next_run_label: string | null;
  format: ScheduledReportFormat;
  recipient_emails: string[];
  recipients: string;
  status: ScheduledReportStatus;
}

/** Form draft used by New/Edit schedule modal. */
export interface ScheduledReportDraft {
  id: string | null;
  report_type: ScheduledReportType;
  location_ids: string[];
  employee_ids: string[];
  frequency_kind: ScheduledReportFrequencyKind;
  weekday: string;
  month_day: number;
  delivery_time: string;
  individual_reports: boolean;
  format: ScheduledReportFormat;
  start_date: Date | null;
  recipient_emails: string[];
}

export function createEmptyScheduleDraft(
  reportType: ScheduledReportType = 'shift',
  defaultRecipientEmail = ''
): ScheduledReportDraft {
  const email = String(defaultRecipientEmail || '').trim();
  return {
    id: null,
    report_type: reportType,
    location_ids: [],
    employee_ids: [],
    frequency_kind: 'shift_end',
    weekday: 'Mon',
    month_day: 1,
    delivery_time: '',
    individual_reports: false,
    format: 'pdf',
    start_date: new Date(),
    recipient_emails: [email],
  };
}
